import {
  WBFlex,
  WBIconButton,
  WBTextField,
  WBTypography,
} from '@admiin-com/ds-web';
import React, { useEffect, useRef, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import LoadSvgIcon from '../../../component/LoadSvgIcon/LoadSvgIcon';
import PenIcon from '../../../../assets/icons/pen-icon.svg';
import { styled } from '@mui/material';

interface Props {
  hideToolbar?: boolean;
  billsCount: number;
}

export const UploadBillsEdit = (props: Props) => {
  const [isEditing, setIsEditing] = React.useState(false);
  const methods = useFormContext();
  const { t } = useTranslation();
  const [textWidth, setTextWidth] = useState(0);
  const textRef = useRef<HTMLSpanElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (textRef.current) {
      setTextWidth(textRef.current.offsetWidth);
    }
  }, [isEditing]);

  useEffect(() => {
    if (inputRef.current) {
      setTextWidth(inputRef.current.scrollWidth + 10);
    }
  }, [methods.watch('reference')]);

  return (
    <WBFlex flexDirection={['column', 'row']}>
      <Controller
        name="reference"
        defaultValue={t('uploadCountNote', { ns: 'taskbox' })}
        control={methods.control}
        render={({ field }) =>
          isEditing ? (
            <ReferenceInput
              {...field}
              inputRef={inputRef}
              onBlur={() => setIsEditing(false)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  setIsEditing(false);
                }
              }}
              placeholder={t('uploadCountNote', { ns: 'taskbox' })}
              fullWidth={false}
              sx={{ width: textWidth, maxWidth: '100%' }}
            />
          ) : (
            <WBFlex alignItems={'center'} gap={1}>
              <RefererenceText noWrap ref={textRef}>
                {`${props.billsCount} ${t('billsUploaded', { ns: 'taskbox' })}`}
              </RefererenceText>
              <WBIconButton size="small" onClick={() => setIsEditing(true)}>
                <LoadSvgIcon component={PenIcon} />
              </WBIconButton>
            </WBFlex>
          )
        }
      />
    </WBFlex>
  );
};
const ReferenceInput = styled(WBTextField)(({ theme }) => ({
  marginTop: -2,
  '& .MuiInput-input': {
    ...theme.typography.h4,
    fontWeight: 500,
    color: theme.palette.grey[800],
    marginBottom: 0,
  },
  height: 40,
  minWidth: 200,
}));

const RefererenceText = styled(WBTypography)(({ theme }) => ({
  ...theme.typography.h4,
  fontWeight: 500,
  marginBottom: 0,
  color: theme.palette.grey[600],
}));
